<template>
  <div>
    <v-tabs
      v-if="TabletSize"
      background-color="#319dd8"
      color="white"
      slider-color="white"
      show-arrows
    >
      <v-tab
        v-for="menu in Menulist"
        :key="menu.route"
        :to="{
          name: menu.route,
        }"
        style="text-transform: none"
        >{{ menu.text }}</v-tab
      >
    </v-tabs>
    <v-navigation-drawer v-if="!TabletSize" permanent clipped app width="200">
      <v-list class="pt-0 mr-3" dense>
        <v-list-item-group color="primary">
          <router-link
            v-for="menu in Menulist"
            :key="menu.route"
            :to="{
              name: menu.route,
            }"
            v-slot="{ isActive }"
            custom
          >
            <v-list-item
              two-line
              router
              :to="{
                name: menu.route,
              }"
              class="my-2 elevation-1 pa-0"
            >
              <v-card
                flat
                tile
                class="pa-0 pl-2 d-flex align-center"
                height="60"
                :style="{
                  'border-left': isActive
                    ? '8px solid #1184bd'
                    : '8px solid grey',
                  'background-color': 'transparent',
                  color: isActive ? '#395da5' : 'grey',
                }"
              >
                <v-list-item-content>
                  <v-list-item-title class="d-flex justify-start align-center"
                    ><v-icon
                      class="mr-6"
                      :color="isActive ? '#2B9ED7' : 'grey'"
                      >{{ menu.icon }}</v-icon
                    ><span style="font-size: 18px">{{
                      menu.text
                    }}</span></v-list-item-title
                  >
                </v-list-item-content>
              </v-card>
            </v-list-item>
          </router-link>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main class="pa-0 ma-0 pb-12">
      <router-view></router-view>
    </v-main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: null,
    };
  },
  created() {
    this.$store.dispatch("getSurvey");
    this.$store.dispatch("getRole");
  },
  computed: {
    Menulist() {
      let menulist = [
        { text: "สรุป", icon: "mdi-view-dashboard", route: "overview" },
        {
          text: "คำถาม",
          icon: "mdi-comment-question-outline",
          route: "question",
        },
        {
          text: "รายงาน",
          icon: "signal_cellular_alt",
          route: "questionsummary",
        },
        { text: "ผู้ใช้งาน", icon: "people", route: "role" },
        { text: "สิทธิการใช้งาน", icon: "key", route: "permission" },
        { text: "ฟอร์ม", icon: "palette", route: "formconfig" },
        { text: "ตั้งค่า", icon: "settings", route: "setting" },
      ];
      let report_view = this.$store.state.user_permission.report.view;
      let account_view = this.$store.state.user_permission.account.view;
      let survey_formconfig = this.$store.state.user_permission.survey.update;
      let survey_update = !Object.values(
        this.$store.state.user_permission.survey
      ).every((value) => !value);
      if (!report_view) {
        menulist = menulist.filter(
          (menu) =>
            menu.route !== "overview" && menu.route !== "questionsummary"
        );
      }
      if (!account_view) {
        menulist = menulist.filter(
          (menu) => menu.route !== "permission" && menu.route !== "role"
        );
      }
      if (!survey_formconfig) {
        menulist = menulist.filter((menu) => menu.route !== "formconfig");
      }
      if (!survey_update && !survey_update) {
        menulist = menulist.filter(
          (menu) => menu.route !== "setting" && menu.route !== "formconfig"
        );
      }
      return menulist;
    },
    QPermission() {
      return this.$store.state.user_permission.account.view;
      // return true;
    },
    storeSurvey() {
      let surveylist = this.$store.state.surveylist;
      surveylist = surveylist.find(
        (search) => search.surveyID === this.$route.params.surveyID
      );
      // console.log(surveylist);
      return surveylist ? surveylist.surveyStatus : false;
    },
    storeRole() {
      let rolelist = this.$store.state.rolelist;
      return rolelist.filter((role) => role.role === "Waiting").length > 0;
    },
    TabletSize() {
      const { smAndDown } = this.$vuetify.breakpoint;
      return smAndDown;
    },
    storeDrawer() {
      return this.$store.state.drawer.state;
    },
  },
};
</script>
